module.exports = __webpack_public_path__ + "static/img/requests.b83d967.svg";